/* eslint-disable max-len */
import {
  Settings,
  Movie,
  Group,
  AccountBox,
  AccountCircle,
  LocationOn,
  InsertLink,
  LiveTv,
} from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserTie, faFile } from "@fortawesome/free-solid-svg-icons";
import { OmekaIcon, WordPressIcon } from "../assets";
import UserService from "../services/UserService";
import {
  AdminExternalResources,
  FromScratchPermissions,
  InteroperabilityPermissions,
  OptionsPermissions,
  Permissions,
  PermissionsManageExternalUsers,
  PermissionsManageFilmOffice,
  PermissionsManageInternalUsers,
  PermissionsRolesManagement,
} from "./permissions";

export const routes_to_hide_navbar = [
  // Admin pages appear at these routes
  "login",
  "auth/keycloak/landpage",
  "admin",
  "admin-login",
];

export const useSideBarOptions = () => {
  const hasSomeInteroperabilityRoles = UserService.hasRole(
    Object.values(InteroperabilityPermissions)
  );

  return [
    ...(UserService.hasRole(Object.values(PermissionsManageFilmOffice))
      ? [
        {
          label: "Οργανικές Μονάδες",
          level: 0,
          link: "/admin/units/dashboard",
          icon: <Movie color='primary' />,
        },
      ]
      : []),
    ...(UserService.hasRole(Object.values(PermissionsManageInternalUsers)) &&
    UserService.hasRole(Object.values(PermissionsManageExternalUsers))
      ? [
        {
          label: "Χρήστες",
          level: 0,
          link: "/admin/users/dashboard",
          icon: <Group color='primary' />,
        },
      ]
      : []),
    ...(UserService.hasRole([
      PermissionsRolesManagement.PermissionsInternalRoleManagementCreate,
      PermissionsRolesManagement.PermissionsInternalRoleManagementRead,
    ])
      ? [
        {
          label: "Διαχείριση Ρόλων",
          level: 0,
          icon: <AccountBox color='primary' />,
          link: "/admin/roles/dashboard",
        },
      ]
      : []),
    ...(UserService.hasRole([
      Permissions.PermissionInternalLocationApplicationCreateMy_org,
    ]) ||
    UserService.hasRole([
      FromScratchPermissions.PermissionsInternalApplicationFromScratchMyOrg,
    ]) ||
    UserService.hasRole([
      FromScratchPermissions.PermissionsInternalApplicationFromScratchAll,
    ])
      ? [
        {
          label: "Αιτήματα",
          level: 0,
          icon: (
            <FontAwesomeIcon
              icon={faFile}
              height='22px'
              style={{ marginLeft: "5" }}
              color='#1622aa'
            />
          ),
          children: [
            ...(UserService.hasRole([
              Permissions.PermissionInternalLocationApplicationCreateMy_org,
            ])
              ? [
                {
                  label: "Συγκεντρωτικός Πίνακας Αιτημάτων",
                  level: 1,
                  link: "/admin/applications/dashboard",
                },
              ]
              : []),
            {
              label: "Τα Εσωτερικά μου Αιτήματα",
              level: 1,
              link: "/admin/applications/my-requests",
            },
            ...(UserService.hasRole([
              FromScratchPermissions.PermissionsInternalApplicationFromScratchMyOrg,
            ]) ||
              UserService.hasRole([
                FromScratchPermissions.PermissionsInternalApplicationFromScratchAll,
              ])
              ? [
                {
                  label: "Διαχείριση Αιτημάτων",
                  level: 1,
                  link: "/admin/applications",
                },
                {
                  label: "Δημιουργία Αιτήματος",
                  level: 1,
                  link: "/admin/applications/new-form",
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    // eslint-disable-next-line no-constant-condition
    ...(UserService.hasRole([
      Permissions.PermissionInternalLocationApplicationCreateMy_org,
    ])
      ? [
        {
          label: "Τοποθεσίες",
          level: 0,
          icon: <LocationOn color='primary' />,
          children: [
            {
              label: "Διαχείριση Τοποθεσιών",
              level: 1,
              link: "/admin/locations/dashboard",
            },
            ...(UserService.hasRole([
              Permissions.PermissionInternalLocationApplicationCreateMy_org,
            ])
              ? [
                {
                  label: "Καταχώριση Νέας Τοποθεσίας",
                  level: 1,
                  link: "/admin/locations/new",
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    ...(UserService.hasRole([
      Permissions.PermissionInternalProfessionalsApplicationCreateMy_org,
      Permissions.PermissionInternalProfessionalsApplicationCreateAll,
      Permissions.PermissionInternalProfessionalsApplicationReadMy_org,
      Permissions.PermissionInternalProfessionalsApplicationReadAll,
    ])
      ? [
        {
          label: "Επαγγελματίες",
          level: 0,
          icon: (
            <FontAwesomeIcon
              icon={faUserTie}
              style={{ marginLeft: "5" }}
              height='22px'
              color='#1622aa'
            />
          ),
          children: [
            ...(UserService.hasRole([
              Permissions.PermissionInternalProfessionalsApplicationReadMy_org,
              Permissions.PermissionInternalProfessionalsApplicationReadAll,
            ])
              ? [
                {
                  label: "Διαχείριση Επαγγελματιών",
                  level: 1,
                  link: "/admin/professionals/dashboard",
                },
              ]
              : []),
            ...(UserService.hasRole([
              Permissions.PermissionInternalProfessionalsApplicationCreateMy_org,
              Permissions.PermissionInternalProfessionalsApplicationCreateAll,
            ])
              ? [
                {
                  label: "Καταχώριση Νέου Επαγγελματία",
                  level: 1,
                  link: "/admin/professionals/new",
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    ...(UserService.hasRole([
      OptionsPermissions.PermissionsInternalOptionsStartOA,
    ])
      ? [
        {
          label: "Ο/Α Υλικό",
          level: 0,
          icon: <LiveTv color='primary' />,
          children: [
            {
              label: "Φορέας",
              level: 1,
              children: [
                {
                  label: "Εκκίνηση Καταχώρισης Φορέα",
                  level: 2,
                  link: "/admin/organisation/registration-organisation",
                },
                {
                  label: "Διαχείριση Φορέα",
                  level: 2,
                  link: "/admin/organisation/dashboard",
                },
              ],
            },
            {
              label: "Συλλογές",
              level: 1,
              children: [
                {
                  label: "Εκκίνηση Καταχώρισης Συλλογής",
                  level: 2,
                  link: "/admin/collection/registration-collection",
                },
                {
                  label: "Διαχείριση Συλλογών",
                  level: 2,
                  link: "/admin/collection/dashboard",
                },
              ],
            },
            {
              label: "Τεκμήριο",
              level: 1,
              children: [
                {
                  label: "Εκκίνηση Καταχώρισης Τεκμηρίου",
                  level: 2,
                  link: "/admin/document/registration-document",
                },
                {
                  label: "Διαχείριση Τεκμηρίων",
                  level: 2,
                  link: "/admin/document/dashboard",
                },
              ],
            },
            {
              label: "Έργο",
              level: 1,
              children: [
                {
                  label: "Εκκίνηση Καταχώρισης Ο/Α Έργου",
                  level: 2,
                  link: "/admin/project/registration-project",
                },
                {
                  label: "Διαχείριση Έργων",
                  level: 2,
                  link: "/admin/project/dashboard",
                },
              ],
            },
          ],
        },
      ]
      : []),
    ...(hasSomeInteroperabilityRoles
      ? [
        {
          label: "Διαλειτουργικότητες",
          level: 0,
          icon: <InsertLink htmlColor='#000000' />,
          children: [
            ...(UserService.hasRole([
              InteroperabilityPermissions.PermissionInternalAadeAfm,
              InteroperabilityPermissions.PermissionInternalAadeName,
              InteroperabilityPermissions.PermissionInternalAadeAdt,
            ])
              ? [
                {
                  label: "ΑΑΔΕ",
                  level: 1,
                  children: [
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionInternalAadeAfm,
                    ])
                      ? [
                        {
                          label: "ΑΦΜ",
                          link: "/admin/interoperability/aade/afm",
                          level: 2,
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionInternalAadeName,
                    ])
                      ? [
                        {
                          label: "Όνομα",
                          link: "/admin/interoperability/aade/name",
                          level: 2,
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionInternalAadeAdt,
                    ])
                      ? [
                        {
                          label: "ΑΔΤ",
                          link: "/admin/interoperability/aade/adt",
                          level: 2,
                        },
                      ]
                      : []),
                    {
                      label: "ΚΑΔ",
                      link: "/admin/interoperability/aade/kad",
                      level: 2,
                    },
                  ],
                },
              ]
              : []),
            ...(UserService.hasRole([
              InteroperabilityPermissions.PermissionsInternalEParavoloForea,
              InteroperabilityPermissions.PermissionsInternalEParavoloPerson,
              InteroperabilityPermissions.PermissionsInternalEParavoloInfo,
              InteroperabilityPermissions.PermissionsInternalEParavoloInfoApplicant,
              InteroperabilityPermissions.PermissionsInternalEParavoloParavoloType,
              InteroperabilityPermissions.PermissionsInternalEParavoloParavoloState,
              InteroperabilityPermissions.PermissionsInternalEParavoloCreate,
            ])
              ? [
                {
                  label: "e-Παράβολο",
                  level: 1,
                  children: [
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalEParavoloForea,
                    ])
                      ? [
                        {
                          label: "Στοιχεία Φορέα",
                          link:
                                  "/admin/interoperability/eparav/foreas-info",
                          level: 2,
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalEParavoloPerson,
                    ])
                      ? [
                        {
                          label: "Παράβολα",
                          link: "/admin/interoperability/eparav/paravola",
                          level: 2,
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalEParavoloInfo,
                      InteroperabilityPermissions.PermissionsInternalEParavoloInfoApplicant,
                      InteroperabilityPermissions.PermissionsInternalEParavoloParavoloType,
                    ])
                      ? [
                        {
                          label: "Ανάκτηση Στοιχείων Παραβόλων",
                          level: 2,
                          children: [
                            ...(UserService.hasRole([
                              InteroperabilityPermissions.PermissionsInternalEParavoloInfo,
                            ])
                              ? [
                                {
                                  label: "Ανάκτηση Πληροφορίας",
                                  link:
                                            "/admin/interoperability/eparav/general-info",
                                  level: 3,
                                },
                              ]
                              : []),
                            ...(UserService.hasRole([
                              InteroperabilityPermissions.PermissionsInternalEParavoloInfoApplicant,
                            ])
                              ? [
                                {
                                  label: "Ανάκτηση Στοιχείων Aιτούντος",
                                  link:
                                            "/admin/interoperability/eparav/applicant-info",
                                  level: 3,
                                },
                              ]
                              : []),
                            ...(UserService.hasRole([
                              InteroperabilityPermissions.PermissionsInternalEParavoloParavoloType,
                            ])
                              ? [
                                {
                                  label: "Ανάκτηση Τύπου Παραβόλου",
                                  link:
                                            "/admin/interoperability/eparav/paravolo-type",
                                  level: 3,
                                },
                              ]
                              : []),
                            ...(UserService.hasRole([
                              InteroperabilityPermissions.PermissionsInternalEParavoloParavoloState,
                            ])
                              ? [
                                {
                                  label:
                                            "Ανάκτηση Κατάστασης Παραβόλου",
                                  link:
                                            "/admin/interoperability/eparav/paravolo-status",
                                  level: 3,
                                },
                              ]
                              : []),
                          ],
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalEParavoloCreate,
                    ])
                      ? [
                        {
                          label: "Δημιουργία Παραβόλου",
                          link: "/admin/interoperability/eparav/new",
                          level: 2,
                        },
                      ]
                      : []),
                  ],
                },
              ]
              : []),
            ...(UserService.hasRole([
              InteroperabilityPermissions.PermissionsInternalGemiVerification,
              InteroperabilityPermissions.PermissionsInternalGemiAdminGroup,
              InteroperabilityPermissions.PermissionsInternalGemiBasicInfo,
            ])
              ? [
                {
                  label: "ΓΕΜΗ",
                  level: 1,
                  children: [
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalGemiVerification,
                    ])
                      ? [
                        {
                          label: "Επιβεβαίωση ΓΕΜΗ",
                          level: 2,
                          link: "/admin/interoperability/gemi/validation",
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalGemiAdminGroup,
                    ])
                      ? [
                        {
                          label:
                                  "Στοιχεία Διοικητικού Συμβουλίου Επιχείρησης",
                          level: 2,
                          link: "/admin/interoperability/gemi/board",
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalGemiBasicInfo,
                    ])
                      ? [
                        {
                          label: "Βασικές Πληροφορίες από Μητρώο ΓΕΜΗ",
                          level: 2,
                          link: "/admin/interoperability/gemi/info",
                        },
                      ]
                      : []),
                  ],
                },
              ]
              : []),
            ...(UserService.hasRole([
              InteroperabilityPermissions.PermissionsInternalIdikaInfo,
              InteroperabilityPermissions.PermissionsInternalIdikaAmka,
              InteroperabilityPermissions.PermissionsInternalIdikaPaaypa,
            ])
              ? [
                {
                  label: "ΗΔΙΚΑ",
                  level: 1,
                  children: [
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalIdikaInfo,
                    ])
                      ? [
                        {
                          label: "Εύρεση Προσωπικών-Στοιχείων",
                          link:
                                  "/admin/interoperability/hdika/personal-data",
                          level: 2,
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalIdikaAmka,
                    ])
                      ? [
                        {
                          label: "Εύρεση AMKA",
                          link: "/admin/interoperability/hdika/amka",
                          level: 2,
                        },
                      ]
                      : []),
                    ...(UserService.hasRole([
                      InteroperabilityPermissions.PermissionsInternalIdikaPaaypa,
                    ])
                      ? [
                        {
                          label: "Εύρεση ΠΑΑΥΠΑ",
                          link: "/admin/interoperability/hdika/paaypa",
                          level: 2,
                        },
                      ]
                      : []),
                  ],
                },
              ]
              : []),
            ...(UserService.hasRole([
              InteroperabilityPermissions.PermissionsInternalBankVerification,
            ])
              ? [
                {
                  label: "Επιβεβαίωση με Τράπεζα",
                  link: "/admin/interoperability/confirm-bank",
                  level: 1,
                },
              ]
              : []),
            ...(UserService.hasRole([
              InteroperabilityPermissions.PermissionsInternalAfeIssue,
              InteroperabilityPermissions.PermissionsInternalAfeValidation,
              InteroperabilityPermissions.PermissionsInternalAfeVersion,
            ])
              ? [
                {
                  label: "ΑΦΕ",
                  link: "/admin/interoperability/afe",
                  level: 1,
                },
              ]
              : []),
            {
              label: "Zoom API",
              level: 1,
              link: "/admin/interoperability/zoom",
            },
          ],
        },
      ]
      : []),
    ...(UserService.hasRole([
      AdminExternalResources.PermissionsInternalWordpressView,
    ])
      ? [
        {
          label: "WordPress",
          level: 0,
          icon: <WordPressIcon />,
          link: "https://www.ekkomed.gr",
          externalLink: true,
        },
      ]
      : []),

    ...(UserService.hasRole([
      AdminExternalResources.PermissionsInternalOmekaView,
    ])
      ? [
        {
          label: "Omeka",
          level: 0,
          icon: <OmekaIcon />,
          link: "https://repository.ekkomed.gr/omeka-s/admin",
          externalLink: true,
        },
      ]
      : []),
    // ...(UserService.hasRole([AdminExternalResources.PermissionsInternalStatisticsView])
    //   ? [{
    //     label: 'Στατιστικά Στοιχεία',
    //     level: 0,
    //     icon: <Equalizer color='primary' />,
    //     link: 'https://app.powerbi.com/links/tG9oMB4Nvr?ctid=857941a5-6cc5-440a-9c89-5d5791d8b0ff&pbi_source=linkShare',
    //     externalLink: true
    //   },
    //   ]
    //   : []),

    ...(UserService.hasRole([
      OptionsPermissions.PermissionsInternalOptionsReviewInteroperability,
      OptionsPermissions.PermissionsInternalOptionsManageApis,
      OptionsPermissions.PermissionsInternalOptionsStartOA,
    ])
      ? [
        {
          label: "Ρυθμίσεις",
          level: 0,
          icon: <Settings color='action' />,
          children: [
            ...(UserService.hasRole([
              OptionsPermissions.PermissionsInternalOptionsReviewInteroperability,
            ])
              ? [
                {
                  label: "Επισκόπηση Διαλειτουργικοτήτων",
                  level: 1,
                  link: "/admin/settings/interoperability",
                },
              ]
              : []),
            ...(UserService.hasRole([
              OptionsPermissions.PermissionsInternalOptionsManageApis,
            ])
              ? [
                {
                  label: "Διαχείριση Χρεώσιμων Apis",
                  level: 1,
                  link: "/admin/settings/apis",
                },
              ]
              : []),
            // eslint-disable-next-line no-constant-condition
            ...(1 === 1
              ? [
                {
                  label: "Επεξεργασία e-mails",
                  level: 1,
                  link: "/admin/settings/emails",
                },
              ]
              : []),
            ...(UserService.hasRole([Permissions.PermisionInternalPDFUpdate])
              ? [{
                label: "ΠΣΚΕ Φόρμες",
                level: 1,
                children: [
                  ...(UserService.hasRole([Permissions.PermisionInternalPDFUpdate])
                    ? [{
                      label: "Αναζήτηση Φορμών",
                      level: 2,
                      link: "/admin/settings/applications",
                    }]
                    : []
                  ),
                  ...(UserService.hasRole([Permissions.PermisionInternalPDFUpdate])
                    ? [{
                      label: "Επεξεργασία Φορμών",
                      level: 2,
                      link: "/admin/settings/edit-applications",
                    }]
                    : []
                  ),
                ]
              }]
              : []
            ),
          ],
        },
      ]
      : []),
    {
      label: "Το προφίλ μου",
      level: 0,
      icon: <AccountCircle htmlColor='#1622aa' />,
      link: "/admin/profile",
    },
  ];
};

export const drawerWidth = 260;

export const CommunicationTypes = [
  { key: "Επένδυση", value: "Επένδυση" },
  { key: "Ψηφιοποίηση", value: "Ψηφιοποίηση" },
  { key: "Εκπαίδευση", value: "Εκπαίδευση" },
  { key: "Τοποθεσίες", value: "Τοποθεσίες" },
  { key: "Επαγγελματίες", value: "Επαγγελματίες" },
  { key: "Καμπάνια", value: "Καμπάνια" },
];
